import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import emailMask from 'text-mask-addons/dist/emailMask';
import { AuthService } from 'app/service/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {

  forgetForm: FormGroup;
  emailMaskHtml = emailMask;

  constructor(
    public fb: FormBuilder,
    public authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.forgetForm = this.fb.group({
      emailForget: ['', [Validators.required, Validators.email]],
    });
  } // fin ngOnInit

  resetPassword() {
    this.authService.resetPassword(this.forgetForm.value).subscribe(
      data => {
        if (data.message === 'Reset Password successfully.') {
          this.forgetForm.reset();
          this.toastr.success('Mail de réinitialisation envoyé!');
        } else if (data.message === 'Email does not exist') {
          this.toastr.warning('Adresse mail introuvable!');
        } else {
          this.toastr.error('Le serveur a rencontré un problème!');
        }
      },
    );
  } // fin resetPassword

}
